import { useEffect, useState } from 'react'

export type WaitTone = 'normal' | 'warn' | 'critical'

export interface WaitThresholds {
  warnMinutes: number
  criticalMinutes: number
}

export const DEFAULT_WAIT_THRESHOLDS: WaitThresholds = { warnMinutes: 15, criticalMinutes: 30 }

/** Los umbrales son del negocio; si no están configurados se usan los del vertical. */
export function resolveWaitThresholds(rawConfig: unknown, fallback: WaitThresholds = DEFAULT_WAIT_THRESHOLDS): WaitThresholds {
  if (!rawConfig || typeof rawConfig !== 'object') return fallback
  const config = rawConfig as Record<string, unknown>
  const warn = Number(config.orderWaitWarnMinutes)
  const critical = Number(config.orderWaitCriticalMinutes)

  const warnMinutes = Number.isFinite(warn) && warn > 0 ? warn : fallback.warnMinutes
  const criticalMinutes =
    Number.isFinite(critical) && critical > 0 ? Math.max(critical, warnMinutes) : fallback.criticalMinutes

  return { warnMinutes, criticalMinutes }
}

export function getWaitMinutes(createdAt: string, now: number): number {
  const created = new Date(createdAt).getTime()
  if (Number.isNaN(created)) return 0
  return Math.max(0, Math.floor((now - created) / 60_000))
}

export function getWaitTone(minutes: number, thresholds: WaitThresholds): WaitTone {
  if (minutes >= thresholds.criticalMinutes) return 'critical'
  if (minutes >= thresholds.warnMinutes) return 'warn'
  return 'normal'
}

export function formatWait(minutes: number): string {
  if (minutes < 60) return `${minutes} min`
  const hours = Math.floor(minutes / 60)
  const rest = minutes % 60
  return rest === 0 ? `${hours} h` : `${hours} h ${rest} min`
}

/** Reloj compartido por las tarjetas: un solo interval para todo el tablero. */
export function useNow(intervalMs = 30_000): number {
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    const handle = window.setInterval(() => setNow(Date.now()), intervalMs)
    return () => window.clearInterval(handle)
  }, [intervalMs])

  return now
}
